"use client";

import { useEffect, useRef, useState } from "react";
import styles from "./ui.module.css";

// Copia un texto al portapapeles y confirma en el mismo lugar, sin ventanas.
export function CopyButton({ text, label = "Copiar", className }: { text: string; label?: string; className?: string }) {
  const [done, setDone] = useState(false);
  const timer = useRef<number | null>(null);

  useEffect(() => () => {
    if (timer.current) window.clearTimeout(timer.current);
  }, []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Sin permiso de portapapeles: selección manual como respaldo.
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setDone(true);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setDone(false), 1800);
  };

  return (
    <button type="button" className={[styles.copy, className].filter(Boolean).join(" ")} onClick={copy} data-done={done ? "true" : undefined}>
      <span aria-live="polite">{done ? "Copiado" : label}</span>
    </button>
  );
}
